import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id 2DD6D091-2E48-41D6-A9E1-67BF485B103E
 * name qrcode-minus
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/qrcode-minus.svg
 * tags
 */
export const QrcodeMinusIcon = createSvgIcon(<><path d="M5 5H7V7H5V5M1 1H11V11H1V1M3 3V9H9V3H3M5 17H7V19H5V17M1 13H11V23H1V13M3 15V21H9V15H3M13 13H17V15H19V13H23V15H19V17H23V23H19V21H15V23H13V21H15V19H13V13M21 21V19H19V21H21M19 17H17V15H15V19H19V17M14 5V7H22V5Z" /></>, 'QrcodeMinusIcon');
export default QrcodeMinusIcon